<div class="tw:flex tw:flex-col tw:flex-1">
  <di-header />
  <div class="tw:flex tw:flex-col tw:flex-1">
    <div class="tw:flex-1" data-testId="page-wrapper">
      <router-outlet />
    </div>
  </div>
</div>
